import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { ErrorService } from '../helpers/errorService';
import { IRmsPlanReviewSchedule } from '../models/rmsPlanReviewSchedule';

@Injectable({
  providedIn: 'root'
})
export class RMSPlanReviewScheduleService {
    constructor(
        private http: HttpClient,
        private errorService: ErrorService
    ) { }

    getRmsPlanReviewScheduleByCaseId(caseId: string): Observable<IRmsPlanReviewSchedule> {
        const url = environment.apiBaseUrl + endpoints.getRMSPlanReviewScheduleByCaseId.replace(':caseId', caseId);
        return this.http.get<IRmsPlanReviewSchedule>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }

    updateRmsPlanReviewSchedule(data: IRmsPlanReviewSchedule): Observable<any> {
        const url = environment.apiBaseUrl + endpoints.updateRMSPlanReviewSchedule;
        return this.http.post(url, data).pipe(
            catchError(this.errorService.handleSavingError)
        );
    }
}